import React from 'react';
import map from 'lodash/map';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import get from 'lodash/get';

const SelectInput = ({ input, meta, options, suffix, valueField, textField, empty, hideError, ...attrs }) => {
  const list = map(options, (option) => {
    let value = option;
    let label = option;
    if (isObject(option)) {
      if (isFunction(textField)) {
        label = textField(option);
      } else {
        label = get(option, textField || 'label');
      }
      value = get(option, valueField || 'value');
    }
    return (
      <option value={value} key={`${input.name}-${value}`}>
        {label}{suffix ? ` ${suffix}` : ''}
      </option>
    );
  });

  if (empty) {
    list.unshift(<option key={`${attrs.name}-empty`} value="">{empty}</option>);
  }

  let validationError = null;
  if (meta && meta.touched && meta.error && !hideError) {
    validationError = (<div className="c-input-error-message">{meta.error}</div>);
  }
  return (
    <div className="u-position-relative">
      <select
        {...input}
        {...attrs}
      >
        {list}
      </select>
      {validationError}
    </div>
  );
};

SelectInput.defaultProps = {
  input: {},
  meta: {},
};

export default SelectInput;
